<template>
  <WorkspaceLayout class="workspace-shell">
    <router-view v-slot="{ Component, route: childRoute }">
      <Transition
        :css="false"
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @enter-cancelled="onEnterCancelled"
        @leave="onLeave"
        @leave-cancelled="onLeaveCancelled"
      >
        <keep-alive
          :include="SHELL_KEEP_ALIVE_NAMES"
          :max="SHELL_KEEP_ALIVE_MAX"
          :key="shellKeepAliveKey"
        >
          <component
            :is="Component"
            v-if="Component"
            :key="shellViewCacheKey(childRoute)"
            class="workspace-shell__page"
          />
        </keep-alive>
      </Transition>
    </router-view>
  </WorkspaceLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import WorkspaceLayout from './components/WorkspaceLayout.vue';
import { useShellPageTransition, bindShellPageRouteTransition } from './composables/useShellPageTransition';
import {
  SHELL_KEEP_ALIVE_MAX,
  SHELL_KEEP_ALIVE_NAMES,
  shellViewCacheKey,
} from './constants/shellKeepAlive';

defineOptions({ name: 'WorkspaceShell' });

const store = useStore();
const {
  prepareRoute,
  onBeforeEnter,
  onEnter,
  onLeave,
  onEnterCancelled,
  onLeaveCancelled,
  unblockPendingTransition,
} = useShellPageTransition();

bindShellPageRouteTransition(prepareRoute, unblockPendingTransition);

const shellKeepAliveKey = ref(0);

watch(
  () => store.state.users?.user?.isLogged,
  (logged, wasLogged) => {
    if (wasLogged && !logged) {
      shellKeepAliveKey.value += 1;
    }
  }
);

watch(
  () => store.state.users?.user?.id,
  (id, prevId) => {
    if (prevId && id && prevId !== id) {
      shellKeepAliveKey.value += 1;
    }
  }
);

onMounted(() => {});

onBeforeUnmount(() => {});
</script>
